import { render, staticRenderFns } from "./ExamInternalFooterA1.vue?vue&type=template&id=c75c8754&scoped=true&"
import script from "./ExamInternalFooterA1.vue?vue&type=script&lang=js&"
export * from "./ExamInternalFooterA1.vue?vue&type=script&lang=js&"
import style0 from "./ExamInternalFooterA1.vue?vue&type=style&index=0&id=c75c8754&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75c8754",
  null
  
)

export default component.exports